const { find } = require('lodash')

const provinces = {
  MI: {
    it: 'milano',
    en: 'milan',
  },
  TO: {
    it: 'torino',
    en: 'turin',
  },
  BS: {
    it: 'brescia',
    en: 'brescia',
  },
  VE: {
    it: 'venezia',
    en: 'venice',
  },
  GE: {
    it: 'genova',
    en: 'genoa',
  },
  BO: {
    it: 'bologna',
    en: 'bologna',
  },
  FI: {
    it: 'firenze',
    en: 'florence',
  },
  RM: {
    it: 'roma',
    en: 'rome',
  },
  NA: {
    it: 'napoli',
    en: 'naples',
  },
  CT: {
    it: 'catania',
    en: 'catania',
  },
  PD: {
    it: 'padova',
    en: 'padua',
  },
}

const urls = {
  it: `/it/affitti-`,
  en: `/en/renting-`,
}

export const createUrl = (language = 'it', province, city_of_reference) => {
  const city = find(provinces, (item, key) => key === province)
  if (city) {
    return `${urls[language]}${city[language]}`
  }
  return `${urls[language]}${city_of_reference?.toLowerCase()}`
}
